import React from "react";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { CONTACT } from "@/lib/constants";

export default function Contact() {
  return (
    <section
      id="contact"
      className="py-20 md:py-32 px-6 md:px-12 bg-brand-clay/40"
      data-testid="contact-section"
    >
      <div className="max-w-7xl mx-auto">
        <div className="max-w-3xl mb-14">
          <span className="text-sm font-semibold tracking-[0.2em] uppercase text-brand-terracotta" data-testid="contact-eyebrow">
            Get in touch
          </span>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-brand-blue mt-4 leading-tight" data-testid="contact-headline">
            Take the first step. We&apos;ll walk the rest with you.
          </h2>
          <p className="text-lg text-slate-700 leading-relaxed mt-6">
            Have a question or ready to book your assessment? Call, text or email us —
            we respond within one working day.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-5">
          <a
            href={`tel:${CONTACT.phone}`}
            className="flex items-start gap-4 p-6 bg-white rounded-2xl border border-brand-clay hover:border-brand-blue/40 hover:shadow-md transition-all"
            data-testid="contact-phone-card"
          >
            <Phone size={28} strokeWidth={1.5} className="text-brand-teal shrink-0" />
            <div>
              <p className="text-sm font-semibold tracking-wide uppercase text-brand-terracotta">Phone</p>
              <p className="font-display text-xl text-brand-blue mt-1">{CONTACT.phoneDisplay}</p>
                <p className="text-sm text-slate-500 mt-1">Tap to call · Mon–Fri</p>
            </div>
          </a>

          <a
            href={`mailto:${CONTACT.email}`}
            className="flex items-start gap-4 p-6 bg-white rounded-2xl border border-brand-clay hover:border-brand-blue/40 hover:shadow-md transition-all"
            data-testid="contact-email-card"
          >
            <Mail size={28} strokeWidth={1.5} className="text-brand-teal shrink-0" />
            <div>
              <p className="text-sm font-semibold tracking-wide uppercase text-brand-terracotta">Email</p>
              <p className="font-display text-xl text-brand-blue mt-1 break-all">{CONTACT.email}</p>
              <p className="text-sm text-slate-500 mt-1">We reply within 1 working day</p>
            </div>
          </a>

          <div
            className="flex items-start gap-4 p-6 bg-white rounded-2xl border border-brand-clay"
            data-testid="contact-address-card"
          >
            <MapPin size={28} strokeWidth={1.5} className="text-brand-teal shrink-0" />
            <div>
              <p className="text-sm font-semibold tracking-wide uppercase text-brand-terracotta">Clinic Address</p>
              <p className="font-display text-xl text-brand-blue mt-1 leading-snug">{CONTACT.address}</p>
              <p className="text-sm text-slate-500 mt-1">Wheelchair accessible · Free parking</p>
            </div>
          </div>

          <div
            className="flex items-start gap-4 p-6 bg-white rounded-2xl border border-brand-clay"
            data-testid="contact-hours-card"
          >
            <Clock size={28} strokeWidth={1.5} className="text-brand-teal shrink-0" />
            <div>
              <p className="text-sm font-semibold tracking-wide uppercase text-brand-terracotta">Opening Hours</p>
              <p className="text-base text-slate-700 mt-2"><span className="font-semibold text-brand-blue">Clinic:</span> {CONTACT.hoursWeek}</p>
              <p className="text-base text-slate-700 mt-1"><span className="font-semibold text-brand-blue">Home visits:</span> available 7 days a week</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
